<template>
    <div class="animated fadeIn">
        <DynamicForm
                v-model="dataId"
                ref="dynamicForm"
                getRoot="/product"
                saveRoot="/product"
                @onTrashClick="onTrashClick"
                @onRequestSuccess="onRequestSuccess"
                :formStructure="dataFormStructures.product">
        </DynamicForm>
        <ModalTrash
                ref="trash"
                root="/product"
                @onTrashSuccess="onTrashSuccess"
                :caption="Core.Definition.getDefinition('Suppression du produit')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer ce produit?')"></ModalTrash>
    </div>
</template>

<script>
    import DynamicForm from '../../components/DynamicForm'
    import ModalTrash from '../../components/ModalTrash'
    export default {
        name: 'Product',
        components: {
            DynamicForm,
            ModalTrash
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataId: '',
                dataFormStructures: {
                    product: {
                        rows: [
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Général'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'title'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'status'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'description'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'shortDescription'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'productCategories'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'formTemplateId'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'plugin'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'pluginFunction'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        lg: 4,
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Image à la une'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'image'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        lg: 8,
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Images'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'images'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        show: Core.Value.encode(Core.Session.Setting.getSetting('commerce.product.ticketIsEnabled'), 'checkbox') || Core.Value.encode(Core.Session.Setting.getSetting('commerce.product.teamIsEnabled'), 'checkbox'),
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Mode participant'),
                                                tabs: [
                                                    {
                                                        show: Core.Value.encode(Core.Session.Setting.getSetting('commerce.product.ticketIsEnabled'), 'checkbox'),
                                                        caption: Core.Definition.getDefinition('Billetterie'),
                                                        rows: [
                                                            {
                                                                cols: [
                                                                    {
                                                                        fields: [
                                                                            {
                                                                                id: 'ticketIsEnabled'
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        fields: [
                                                                            {
                                                                                id: 'ticketTemplateId'
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        show: Core.Value.encode(Core.Session.Setting.getSetting('commerce.product.teamIsEnabled'), 'checkbox'),
                                                        caption: Core.Definition.getDefinition('Équipe'),
                                                        rows: [
                                                            {
                                                                cols: [
                                                                    {
                                                                        fields: [
                                                                            {
                                                                                id: 'teamIsEnabled'
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        fields: [
                                                                            {
                                                                                id: 'teamId'
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                cols: [
                                                                    {
                                                                        fields: [
                                                                            {
                                                                                id: 'teamlessIsEnabled'
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        fields: [
                                                                            {
                                                                                id: 'teamCreationIsEnabled'
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        show: Core.Value.encode(Core.Session.Setting.getSetting('commerce.product.participantCategoryIsEnabled'), 'checkbox'),
                                                        caption: Core.Definition.getDefinition('Catégorie de participant'),
                                                        rows: [
                                                            {
                                                                cols: [
                                                                    {
                                                                        fields: [
                                                                            {
                                                                                id: 'participantCategoryIsEnabled'
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        fields: [
                                                                            {
                                                                                id: 'participantCategoryId'
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        show: Core.Value.encode(Core.Session.Setting.getSetting('commerce.product.tshirtIsEnabled'), 'checkbox'),
                                                        caption: Core.Definition.getDefinition('T-shirt'),
                                                        rows: [
                                                            {
                                                                cols: [
                                                                    {
                                                                        fields: [
                                                                            {
                                                                                id: 'tshirtSizeIsEnabled'
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        fields: [
                                                                            {
                                                                                id: 'tshirtSize'
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                cols: [
                                                                    {
                                                                        fields: [
                                                                            {
                                                                                id: 'tshirtCustomNameIsEnabled'
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        show: Core.Value.encode(Core.Setting.getSetting('commerce.product.autoBookingIsEnabled'), 'checkbox') || Core.Value.encode(Core.Session.Setting.getSetting('commerce.product.conditionalIsEnabled'), 'checkbox'),
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Options avancés'),
                                                tabs: [
                                                    {
                                                        show: Core.Value.encode(Core.Session.Setting.getSetting('commerce.product.autoBookingIsEnabled'), 'checkbox'),
                                                        caption: Core.Definition.getDefinition('Réservation automatique'),
                                                        rows: [
                                                            {
                                                                cols: [
                                                                    {
                                                                        fields: [
                                                                            {
                                                                                id: 'autoBookingIsEnabled'
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        show: Core.Value.encode(Core.Session.Setting.getSetting('commerce.product.conditionalIsEnabled'), 'checkbox'),
                                                        caption: Core.Definition.getDefinition('Conditionnelle'),
                                                        rows: [
                                                            {
                                                                cols: [
                                                                    {
                                                                        fields: [
                                                                            {
                                                                                id: 'conditionalIsEnabled'
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        fields: [
                                                                            {
                                                                                id: 'conditionalAutoBookingIsEnabled'
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                cols: [
                                                                    {
                                                                        show: Core.Value.encode(Core.Setting.getSetting('event.seasonIsEnabled'), 'checkbox'),
                                                                        fields: [
                                                                            {
                                                                                id: 'conditionalForceSeasonId'
                                                                            },
                                                                            {
                                                                                id: 'conditionalSeasonId'
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        show: Core.Value.encode(Core.Setting.getSetting('event.leagueIsEnabled'), 'checkbox'),
                                                                        fields: [
                                                                            {
                                                                                id: 'conditionalForceLeagueId'
                                                                            },
                                                                            {
                                                                                id: 'conditionalLeagueId'
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        show: Core.Value.encode(Core.Setting.getSetting('event.placeIsEnabled'), 'checkbox'),
                                                                        fields: [
                                                                            {
                                                                                id: 'conditionalForceDistrictId'
                                                                            },
                                                                            {
                                                                                id: 'conditionalDistrictId'
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                cols: [
                                                                    {
                                                                        fields: [
                                                                            {
                                                                                id: 'conditionalForceDate'
                                                                            },
                                                                            {
                                                                                id: 'conditionalDateConditionals'
                                                                            },
                                                                            {
                                                                                id: 'conditionalDateConditionalTag'
                                                                            },
                                                                            {
                                                                                id: 'conditionalDateCount'
                                                                            }
                                                                        ]
                                                                    },
                                                                    {

                                                                    },
                                                                    {

                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Données de produit'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'productData'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'autoBookingIsEnabled',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Activer la réservation automatique'),
                                value: false,
                                onChange: function(val, form, fieldRefs) {
                                    //fieldRefs['autoBookingEventId'].isVisible = val
                                }
                            },
                            {
                                id: 'autoBookingEventId',
                                type: 'instanceSelector',
                                label: Core.Definition.getDefinition('Événement spécifique'),
                                value: {},
                                isVisible: false,
                                emptyMessage: Core.Definition.getDefinition('Aucun événement sélectionné'),
                                instanceSelector: {
                                    root: '/event-date/list',
                                    searchFormStructure: {
                                        rows: [
                                            {
                                                cols: [
                                                    {
                                                        fields: [
                                                            {
                                                                id: 'start'
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        fields: [
                                                            {
                                                                id: 'eventId'
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ],
                                        fields: [
                                            {
                                                id: 'start',
                                                type: 'datePicker',
                                                isInline: false,
                                                label: Core.Definition.getDefinition('Date'),
                                                value: null,
                                                onChange: function() {}
                                            },
                                            {
                                                id: 'eventId',
                                                type: 'select',
                                                label: Core.Definition.getDefinition('Événement'),
                                                value: null,
                                                onSelect: function() {}
                                            }
                                        ]
                                    },
                                    data: {},
                                    options: {
                                        pagination: true,
                                        header: true,
                                        responsive: false,
                                        striped: true,
                                        headerStyle: '1',
                                        emptyText: Core.Definition.getDefinition('Aucun élément à afficher'),
                                        borderVariant: 'white',
                                        noBody: true
                                    },
                                    columns: [
                                        {
                                            label: Core.Definition.getDefinition('Date'),
                                            key: 'start',
                                            type: 'date',
                                            format: 'DD MMM YYYY HH:mm',
                                            sortable: true
                                        },
                                        {
                                            label: Core.Definition.getDefinition('Titre'),
                                            key: 'title',
                                            sortable: true
                                        }
                                    ],
                                    label: ['start', 'title'],
                                    id: 'id'
                                }
                            },
                            {
                                id: 'conditionalAutoBookingIsEnabled',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Activer la réservation automatique sur les conditionnelles'),
                                description: Core.Definition.getDefinition('La réservation se fera automatiquement sur les événements qui respecteront les conditions spécifiées.'),
                                value: false,
                                onChange: function() {}
                            },
                            {
                                id: 'conditionalIsEnabled',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Activer les conditionnelles'),
                                description: Core.Definition.getDefinition('Le détenteur du produit pourra réserver un ou des événements selon les conditions spécifiées. Notez que si l\'événement est associé à un produit requis et que le client le détient, celui-ci est priorisé'),
                                value: false,
                                onChange: function(val, form, fieldRefs) {
                                    if (Core.Value.encode(Core.Setting.getSetting('event.seasonIsEnabled'), 'checkbox')) {
                                        fieldRefs['conditionalForceSeasonId'].isVisible = val
                                        fieldRefs['conditionalSeasonId'].isVisible = val
                                    }
                                    if (Core.Value.encode(Core.Setting.getSetting('event.leagueIsEnabled'), 'checkbox')) {
                                        fieldRefs['conditionalForceLeagueId'].isVisible = val
                                        fieldRefs['conditionalLeagueId'].isVisible = val
                                    }
                                    if (Core.Value.encode(Core.Setting.getSetting('event.placeIsEnabled'), 'checkbox')) {
                                        fieldRefs['conditionalForceDistrictId'].isVisible = val
                                        fieldRefs['conditionalDistrictId'].isVisible = val
                                    }
                                    if (fieldRefs['conditionalAutoBookingIsEnabled'].dataValue) {
                                        fieldRefs['conditionalAutoBookingIsEnabled'].isVisible = val
                                    }
                                    fieldRefs['conditionalForceDate'].isVisible = val
                                }
                            },
                            {
                                id: 'conditionalForceSeasonId',
                                type: 'checkbox',
                                description: Core.Definition.getDefinition('Si coché, le client sera forcé de choisir une saison parmi les saisons sélectionnées ou une saison parmi toutes les saisons si aucune n\'est sélectionnée.'),
                                label: Core.Definition.getDefinition('Forcer la sélection d\'une saison'),
                                value: false,
                                onChange: function() {}
                            },
                            {
                                id: 'conditionalSeasonId',
                                type: 'multiSelect',
                                description: Core.Definition.getDefinition('Si laissé vide toutes les saisons seront disponbles.'),
                                label: Core.Definition.getDefinition('Choix des saisons'),
                                value: null,
                                isVisible: false,
                                onSelect: function() {}
                            },
                            {
                                id: 'conditionalForceLeagueId',
                                type: 'checkbox',
                                description: Core.Definition.getDefinition('Si coché, le client sera forcé de choisir une ligue parmi les ligues sélectionnées ou une ligue parmi toutes les ligues si aucune n\'est sélectionnée.'),
                                label: Core.Definition.getDefinition('Forcer la sélection d\'une ligue'),
                                value: false,
                                isVisible: false,
                                onChange: function() {}
                            },
                            {
                                id: 'conditionalLeagueId',
                                type: 'multiSelect',
                                description: Core.Definition.getDefinition('Si laissé vide toutes les ligues seront disponibles.'),
                                label: Core.Definition.getDefinition('Choix des ligues'),
                                value: null,
                                isVisible: false,
                                onSelect: function() {}
                            },
                            {
                                id: 'conditionalForceDistrictId',
                                type: 'checkbox',
                                description: Core.Definition.getDefinition('Si coché, le client sera forcé choisir une région parmi les régions sélectionnées ou une région parmi toutes les régions si aucune n\'est sélectionnée.'),
                                label: Core.Definition.getDefinition('Forcer la sélection d\'une région'),
                                value: false,
                                isVisible: false,
                                onChange: function() {}
                            },
                            {
                                id: 'conditionalDistrictId',
                                type: 'multiSelect',
                                description: Core.Definition.getDefinition('Si laissé vide toutes les régions seront disponibles.'),
                                label: Core.Definition.getDefinition('Choix des régions'),
                                value: null,
                                isVisible: false,
                                onSelect: function() {}
                            },
                            {
                                id: 'conditionalForceDate',
                                type: 'checkbox',
                                description: Core.Definition.getDefinition('Le client sera forcé choisir une ou plusieurs dates.'),
                                label: Core.Definition.getDefinition('Forcer la sélection de date(s)'),
                                value: false,
                                isVisible: false,
                                onChange: function(val, form, fieldRefs) {
                                    fieldRefs['conditionalDateCount'].isVisible = val
                                    fieldRefs['conditionalDateConditionals'].isVisible = val
                                    fieldRefs['conditionalDateConditionalTag'].isVisible = val
                                }
                            },
                            {
                                id: 'conditionalDateConditionals',
                                type: 'multiSelect',
                                label: Core.Definition.getDefinition('Baser les dates sur les conditionnelles'),
                                description: Core.Definition.getDefinition('Les dates proposées seront filtrées selon les conditionnelles sélectionnées par l\'utilisateur. Si laissé vide, toutes les dates futures seront affichées.'),
                                value: null,
                                isVisible: false,
                                onSelect: function() {}
                            },
                            {
                                id: 'conditionalDateConditionalTag',
                                type: 'text',
                                label: Core.Definition.getDefinition('Baser les dates sur les tags'),
                                description: Core.Definition.getDefinition('Les dates proposées seront filtrées selon le tags spécifés. Séparez les tags par une virgule (,).'),
                                value: '',
                                isVisible: false
                            },
                            {
                                id: 'conditionalDateCount',
                                type: 'select',
                                label: Core.Definition.getDefinition('Nombre de date(s)'),
                                value: null,
                                isVisible: false,
                                onSelect: function() {}
                            },
                            {
                                id: 'tshirtSizeIsEnabled',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Autoriser la sélection d\'une taille'),
                                value: false,
                                onChange: function() {}
                            },
                            {
                                id: 'tshirtCustomNameIsEnabled',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Autoriser l\'ajout d\'un nom personnalisé'),
                                value: false,
                                onChange: function() {}
                            },
                            {
                                id: 'tshirtSize',
                                type: 'multiSelect',
                                description: Core.Definition.getDefinition('Laissez vide pour afficher toutes les tailles.'),
                                label: Core.Definition.getDefinition('Afficher les tailles sélectionnées'),
                                value: null,
                                onSelect: function() {}
                            },
                            {
                                id: 'ticketIsEnabled',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Générer un billet de l\'achat du produit.'),
                                value: false,
                                onChange: function() {}
                            },
                            {
                                id: 'ticketTemplateId',
                                type: 'select',
                                label: Core.Definition.getDefinition('Gabarit du billet'),
                                value: null,
                                onSelect: function() {}
                            },
                            {
                                id: 'teamIsEnabled',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Autoriser la sélection d\'une équipe'),
                                value: false,
                                onChange: function() {}
                            },
                            {
                                id: 'teamCreationIsEnabled',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Autoriser la création d\'une nouvelle équipe'),
                                value: false,
                                onChange: function() {}
                            },
                            {
                                id: 'teamlessIsEnabled',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Autoriser les sans équipes'),
                                value: false,
                                onChange: function() {}
                            },
                            {
                                id: 'teamId',
                                type: 'multiSelect',
                                description: Core.Definition.getDefinition('Laissez vide pour afficher toutes les équipes.'),
                                label: Core.Definition.getDefinition('Afficher les équipes sélectionnées'),
                                value: null,
                                onSelect: function() {}
                            },
                            {
                                id: 'participantCategoryIsEnabled',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Autoriser la sélection d\'une catégorie'),
                                value: false,
                                onChange: function() {}
                            },
                            {
                                id: 'participantCategoryId',
                                type: 'multiSelect',
                                description: Core.Definition.getDefinition('Laissez vide pour afficher toutes les catégories.'),
                                label: Core.Definition.getDefinition('Afficher les catégories sélectionnées'),
                                value: null,
                                onSelect: function() {}
                            },
                            {
                                id: 'productCategories',
                                type: 'multiSelect',
                                label: Core.Definition.getDefinition('Catégories du produit'),
                                value: null,
                                onSelect: function() {}
                            },
                            {
                                id: 'title',
                                type: 'text',
                                label: Core.Definition.getDefinition('Titre'),
                                value: '',
                                required: true,
                                multiLingual: Core.Local.isMultilingualInstance('product')
                            },
                            {
                                id: 'status',
                                type: 'select',
                                label: Core.Definition.getDefinition('État'),
                                value: Core.Select.select(Core.Instance.statusPublish, Core.Instance.statusOptions()),
                                onSelect: function() {}
                            },
                            {
                                id: 'description',
                                type: 'editor',
                                label: Core.Definition.getDefinition('Description'),
                                value: '',
                                multiLingual: Core.Local.isMultilingualInstance('product')
                            },
                            {
                                id: 'shortDescription',
                                type: 'longText',
                                label: Core.Definition.getDefinition('Description courte'),
                                value: '',
                                multiLingual: Core.Local.isMultilingualInstance('product')
                            },
                            {
                                id: 'image',
                                placeholder: Core.Definition.getDefinition('Téléversez une image à la une'),
                                type: 'image',
                                label: Core.Definition.getDefinition('Image principale affichée dans la boutique'),
                                value: [],
                                thumbnailWidth: 500,
                                maxFilesize: 5
                            },
                            {
                                id: 'images',
                                type: 'images',
                                placeholder: Core.Definition.getDefinition('Téléversez des images'),
                                label: Core.Definition.getDefinition('Images supplémentaires du produit'),
                                value: []
                            },
                            {
                                id: 'formTemplateId',
                                type: 'select',
                                label: Core.Definition.getDefinition('Formulaire'),
                                description: Core.Definition.getDefinition('Formulaire que l\'usager doit compléter lors de l\'achat.'),
                                value: null,
                                onSelect: function(val) {}
                            },
                            {
                                id: 'productData',
                                type: 'productData',
                                value: {
                                    type: Core.Select.select(Core.Product.typeStandard, Core.Product.typeOptions()),
                                    regularPrice: '',
                                    periodLength: '0',
                                    period: Core.Select.select(Core.Product.periodMonth, Core.Product.periodOptions()),
                                    periodPaymentInterval: Core.Select.select(Core.Product.periodIntervalOne, Core.Product.periodIntervalOptions()),
                                    periodPayment: Core.Select.select(Core.Product.periodMonth, Core.Product.periodOptions()),
                                    periodPaymentLength: '0',
                                    expirationPeriod: Core.Select.select(Core.Product.periodMonth, Core.Product.periodOptions()),
                                    expirationPeriodLength: '0',
                                    bookingLimitManagement: false,
                                    isTaxable: true,
                                    bookingLimit: '0',
                                    attributes: [],
                                    variations: []
                                }
                            },
                            {
                                id: 'plugin',
                                type: 'text',
                                label: Core.Definition.getDefinition('Extension'),
                                value: ''
                            },
                            {
                                id: 'pluginFunction',
                                type: 'text',
                                label: Core.Definition.getDefinition('Fonction'),
                                value: ''
                            }
                        ]
                    }
                }
            }
        },
        methods: {
            onRequestSuccess(data) {
            },
            onTrashClick(id) {
                this.$refs.trash.open(id)
            },
            onTrashSuccess() {
                this.$router.push('/commerce/produits')
            }
        }
    }
</script>
